import { PlatformIcon, ValidPlatform } from "./PlatformIcon";

type PlatformBadgeProps = {
  value: ValidPlatform;
  nameClassName?: string;
  hideIcon?: boolean;
  hideName?: boolean;
  onClick?: (platform: ValidPlatform) => void;
  className?: string;
};

function getPlatformName(value: ValidPlatform): string {
  return {
    chatgpt: "ChatGPT",
    claude: "Claude",
    google_gemini: "Gemini",
    perplexity: "Perplexity",
    meta: "Meta AI",
    google_ai_mode: "Google AI Mode",
    google_ai_overviews: "AI Overviews",
  }[value];
}

export function PlatformBadge({
  value,
  nameClassName,
  hideIcon = false,
  hideName = false,
  onClick,
  className,
}: PlatformBadgeProps) {
  const platformName = getPlatformName(value);

  const content = (
    <div className={`flex items-center gap-1 px-1 py-1 ${!onClick ? (className || '') : ''}`}>
      {!hideIcon && <PlatformIcon platform={value} size={16} />}
      {!hideName && <span className={`text-sm font-medium text-slate-700 ${nameClassName}`}>{platformName}</span>}
    </div>
  );

  if (onClick) {
    return (
      <button className={`cursor-pointer transition-colors ${className || ''}`} onClick={() => onClick(value)}>
        {content}
      </button>
    );
  }

  return content;
}
